import React, { useEffect, useRef, useState } from 'react';
import TreeSelectCategory from '@/form-component/tree-select-category';

const SkuTree = (props: any) => {
  const { value, onChange, placeholder, disabled, isUpdate, width } = props;
  const [selectVal, setSelectVal] = useState([] as string[]);

  // 选中值
  useEffect(() => {
    if (typeof value === 'string') setSelectVal(value.split(','));
    // setSelectVal(getValue(JSON.parse(value)))
  }, [value]);

  const ref: any = useRef();

  // 数据变化
  const changeVal = (checkedValues: any) => {
    onChange(ref.current.mergeValue(checkedValues).join(','));
  };

  return (
    <TreeSelectCategory
      ref={ref}
      placeholder={placeholder}
      value={selectVal}
      show={isUpdate}
      style={{ width: width || '100%' }}
      disabled={disabled}
      hasSelectAll
      onChange={changeVal}
    />
  );
};

export default React.memo(SkuTree);
